import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { get, put } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageLoader, PageHeader, Badge, statusTone } from "@/components/common";

export default function TeacherProfile() {
  const { user, refresh } = useAuth();
  const { data, isLoading, refetch } = useQuery({ queryKey: ["teacher-dash-profile"], queryFn: () => get("/dashboard/teacher") });
  const [form, setForm] = useState(null);
  useEffect(() => { if (data?.profile) setForm(data.profile); }, [data]);
  const save = async () => { await put("/auth/profile", { full_name: form.full_name, mobile: form.mobile, bio: form.bio, subjects: form.subjects, exam_expertise: form.exam_expertise, languages: form.languages }); toast.success("Profile updated"); refresh(); refetch(); };
  if (isLoading || !form) return <PageLoader />;
  return (
    <div>
      <PageHeader title="Teacher Profile" subtitle="Manage your public teaching profile" />
      <div className="grid lg:grid-cols-3 gap-5">
        <div className="bg-white rounded-2xl border border-slate-200 p-5 text-center">
          <div className="h-20 w-20 rounded-full bg-teal-700 text-white flex items-center justify-center font-display font-extrabold text-2xl mx-auto">{user.name?.slice(0, 1)}</div>
          <h3 className="font-display font-bold text-lg mt-3">{user.name}</h3>
          <p className="text-sm text-slate-500">{user.email}</p>
          <div className="mt-2"><Badge tone={statusTone(form.approval_status)}>{form.approval_status}</Badge></div>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 p-5 lg:col-span-2 space-y-3">
          <L label="Full Name"><input value={form.full_name || ""} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="inp" data-testid="tp-name" /></L>
          <L label="Mobile"><input value={form.mobile || ""} onChange={(e) => setForm({ ...form, mobile: e.target.value })} className="inp" data-testid="tp-mobile" /></L>
          <L label="Bio"><textarea value={form.bio || ""} onChange={(e) => setForm({ ...form, bio: e.target.value })} rows={3} className="inp" data-testid="tp-bio" /></L>
          <L label="Subjects (comma separated)"><input value={(form.subjects || []).join(", ")} onChange={(e) => setForm({ ...form, subjects: e.target.value.split(",").map((s) => s.trim()) })} className="inp" data-testid="tp-subjects" /></L>
          <button onClick={save} data-testid="save-teacher-profile-btn" className="bg-indigo-800 text-white font-semibold px-5 py-2 rounded-lg">Save</button>
        </div>
      </div>
      <style>{`.inp{width:100%;border:1px solid #E2E8F0;border-radius:.5rem;padding:.55rem .7rem;font-size:.875rem;outline:none;}`}</style>
    </div>
  );
}
const L = ({ label, children }) => <label className="block"><span className="text-xs font-semibold text-slate-600">{label}</span><div className="mt-1">{children}</div></label>;
